import React from 'react';
import PropTypes from 'prop-types';

import FilterButton from './Button';

const ClearButton = ({ onClick }) => (
	<FilterButton
		onClick={onClick}
		icon="close-bold"
		tooltip="Очистить все фильтры"
		title="Очистить"
		theme="clear"
		aria-label="Очистить все фильтры"
	/>
);

ClearButton.propTypes = {
	onClick: PropTypes.func.isRequired
};

export default ClearButton;
